import React, {Fragment} from 'react';
import Formatters from '../../shared/utils/Formatters';

import LoanPlan from './LoanPlan';
import EmptyState from './EmptyState';

export default function LoanSummary({
  bank_accounts,
  loans,
  caption,
  onClickLoanPlan,
}) {
  return (
    <Fragment>
      <div className="pageHeader">
        <h2 className="headline">{Formatters.upperCaseWords(caption)}</h2>
      </div>
      <div className="ds-cardList">
        {loans.length === 0 && <EmptyState type={caption} />}
        {loans.map(loan_plan => {
          return (
            <LoanPlan
              key={loan_plan.id}
              bank_accounts={bank_accounts}
              onClick={onClickLoanPlan}
              {...loan_plan}
            />
          );
        })}
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/features/loans/components/LoanPlanItems.js